import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Row, Col, Select } from 'antd'
import { updateIntl } from 'react-intl-redux'
import msEs from '../../translations/es.json'
import msEn from '../../translations/en.json'
import store from '../../store'

const { Option } = Select

export class ChangeLanguage extends Component {

  hanleOnChange = value => {
    store.dispatch(updateIntl({
      locale: value,
      messages: value === 'es'
        ? msEs
        : msEn
    }))
  }

  render() {
    const { intl_prop, intl } = this.props
    return (
      <Row style={{ padding: '10px 0 0 5px' }}>
        <Col>{intl.formatMessage({ id: "select_language" })}</Col>
        <Col>
          <Select defaultValue={intl_prop.locale} onChange={this.hanleOnChange} style={{ width: 120 }}>
            <Option value="es">ES</Option>
            <Option value="en">EN</Option>
          </Select>
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = state => {
  return {
    intl_prop: state.intl
  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangeLanguage)))